import { useContext } from 'react'
import WrappedStoryStateContext from './wrappedStoryStateContext'

function useWrappedStoryState() {
  return useContext(WrappedStoryStateContext)
}

export default useWrappedStoryState
